import Swiperone from "../classes/Swiperone";
import BookLoftForm from "../classes/BookLoftForm";

export default class SingleSpace {
  constructor(page, data) {
    this.page = page;
    this.swiper = null;
    this.data = data;
  }

  init() {
    this.initBookLoftForm();    
    this.initSwipers();
    this.initPostGalleryGrid();
  }  

  initSwipers() {
    this._initSpacesSwiperone();
    this._initLayerSwiper();
  }

  _initSpacesSwiperone() {
    const swiperonies = this.page.querySelectorAll(".js-swiper-spaces");
    swiperonies?.forEach((swiper) => {
      const swiperone = new Swiperone(swiper, {
          draggable: true,
          pagination: true,
          excerpt: ".js-current-space-desc",
          btnLink: ".js-btn-space-cta"
        }
      );
      swiperone?.init();
    });
  }

  _initLayerSwiper() {
    this.swiper = new Swiper(".js-swiper-gallery", {
      autoplay: false,
      grabCursor: true,
      disableOnInteraction: true,
      navigation: {
        nextEl: ".js-swiper-button-next",
        prevEl: ".js-swiper-button-prev" 
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      }
    });
  } 

  initBookLoftForm() {
    const forms = this.page.querySelectorAll(".js-form-book-loft");
    forms?.forEach((form, i) => {
      const bookLoftForm = new BookLoftForm(form, i, this.data);
      bookLoftForm.init();      
    });
  }

  initPostGalleryGrid() {
    const galleryImgs = this.page.querySelectorAll(".post-gallery-preview-wrap > img");    
    const btn = this.page.querySelector(".js-btn-show-gallery");
    const galleryGrid = document.querySelector(".js-post-gallery-grid");
    const swiperCont = document.querySelector(".js-post-gallery-swiper-cont");

    galleryImgs?.forEach((img, i) => {
      img.addEventListener("click", (e) => {
        if (!galleryGrid?.classList.contains("is-visible")) {
          galleryGrid.classList.add("is-visible");
          document.querySelector("html").classList.add("overflow-hidden");          
          galleryGrid.scrollTo({
            top: galleryGrid.querySelectorAll("img")[i]?.offsetTop,
            left: 0,
            behavior: "smooth"
          });     
        }  
      });
    })

    btn?.addEventListener("click", (e) => {
      if (!galleryGrid?.classList.contains("is-visible")) {
        galleryGrid.classList.add("is-visible");
        document.querySelector("html").classList.add("overflow-hidden");
      }
    });

    swiperCont?.querySelector(".js-btn-close-swiper")?.addEventListener("click", (e) => {
      swiperCont.classList.remove("is-visible");

      setTimeout(() => {
        galleryGrid?.classList.remove("is-visible");
        document.querySelector("html").classList.remove("overflow-hidden");
      }, 200);
    })

    if (galleryGrid) {
      const galleryGridImgs = galleryGrid.querySelectorAll(".js-gallery-grid img");      
      const btnClose = galleryGrid.querySelector(".js-btn-close");
      galleryGridImgs?.forEach((img, i) => {
        img.addEventListener("click", (e) => {
          if (!swiperCont?.classList.contains("is-visible")) {
            swiperCont.classList.add("is-visible");
            this.swiper.slideTo(i);
          }
        });
      });

      btnClose?.addEventListener("click", (e) => {
        galleryGrid.classList.remove("is-visible");
        document.querySelector("html").classList.remove("overflow-hidden");
      });
    }
  }
}